<script lang="ts">
	import type { SupportedLocale } from '@viamichelin/business';
	import MagazineLoginBackground from '$assets/ad/magazine-login.webp';
	import MagazineNewsletterBackground from '$assets/ad/magazine-newsletter.webp';
	import LogoLarge from '$assets/logos/vm-logo-large.svg';
	import MagazineAdBase from '$lib/components/advertising/magazine/MagazineAdBase.svelte';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { isLocaleAuthorizedToShowRegistrations, mapNewsletterRegistrationLinksByLocale } from '$lib/components/footer/newsletterRegistrationLinks';
	import Icon from '$lib/components/icons/Icon.svelte';
	import { accountModalActions, trackAccountModalClick } from '$lib/services/tracking/googleAnalytics/accountModal';
	import { formatMagazineUrlWithTracking, magazineMediumMap } from '$lib/services/tracking/googleAnalytics/magazine';
	import * as m from '$paraglide/messages';

	const adGradient = 'linear-gradient(0deg, rgba(20, 65, 89, 0) 29.26%, rgba(20, 65, 89, 0.9) 100%)';

	interface Props {
		onClickLogin?: any;
		locale?: SupportedLocale;
	}

	const {
		onClickLogin,
		locale = 'en-US',
	}: Props = $props();

	function handleLoginClick() {
		trackAccountModalClick(accountModalActions.signInAccountBtn);
		onClickLogin?.();
	}

	function handleSignUpClick() {
		trackAccountModalClick(accountModalActions.registerAccountBtn);
		onClickLogin?.();
	}
</script>

<div class="flex flex-col gap-4 md:gap-2 md:flex-row" data-testid="account-modal">
	<div class="flex items-center bg-neutral-weakest rd-1 px-4 py-8 md:max-w-450px">
		<div class="flex flex-col gap-y-6">
			<div>
				<img class="h-9" src={LogoLarge} alt="ViaMichelin" />
			</div>
			<h2 class="text-title-regular m-0">
				{m.launchpad__account_modal_create()}
			</h2>
			<ul class="flex flex-col text-md text-coloredneutral list-reset gap-y-2">
				<li class="gap-x-2 flex items-start gap-x-2">
					<Icon icon="tune" class="flex-shrink-0 m-0.5" />
					<span>{m.launchpad__account_modal_save_pref()}</span>
				</li>
				<li class="gap-x-2 flex items-start gap-x-2">
					<Icon icon="car" class="flex-shrink-0 m-0.5" />
					<span>{m.launchpad__account_modal_add_car()}</span>
				</li>
				<li class="gap-x-2 flex items-start gap-x-2">
					<Icon icon="bookmark-plus" class="flex-shrink-0 m-0.5" />
					<span>{m.bookmark__save_favorite_route()}</span>
				</li>
			</ul>
			<div class="flex">
				<Button text={m.profile__login()} onclick={handleLoginClick} />
				<Button variant="ghost" text={m.launchpad__account_modal_create_account()} onclick={handleSignUpClick} />
			</div>
		</div>
	</div>
	<div class="flex flex-col gap-y-4 md:gap-y-2 md:max-w-283px">
		<MagazineAdBase
			text={m.ad__magazine__first_line()}
			secondText={m.ad__magazine__second_line()}
			ctaText={m.launchpad__account_modal_more()}
			backgroundUrl={MagazineLoginBackground}
			ctaIcon="menu-book"
			gradient={adGradient}
			ctaHref={formatMagazineUrlWithTracking(magazineMediumMap.learnMoreAccountBenefits, locale)}
			onclick={() => trackAccountModalClick(accountModalActions.magRedirection)}
		/>
		{#if isLocaleAuthorizedToShowRegistrations(locale)}
			<MagazineAdBase
				text={m.launchpad__account_modal_ideas()}
				secondText={m.launchpad__account_modal_newsletter()}
				ctaText={m.launchpad__account_modal_signin()}
				backgroundUrl={MagazineNewsletterBackground}
				ctaIcon="mail"
				ctaHref={mapNewsletterRegistrationLinksByLocale[locale]}
				gradient={adGradient}
				onclick={() => trackAccountModalClick(accountModalActions.signInNlBtn)}
			/>
		{/if}
	</div>
</div>
